import React from "react";
import "./ValidationErrorMessage.scss";

const ValidationErrorMessage = ({ children }) => {
  return (
    <div className="error-container">
      <div className="error-message">{children}</div>
    </div>
  );
};

export default ValidationErrorMessage;
